import React from 'react';

const SectionBadge = ({ children }) => (
  <span className="inline-flex items-center px-3.5 py-1.5 rounded-full text-xs font-semibold bg-[#1c587a]/10 text-[#1c587a] border border-[#1c587a]/20 tracking-widest uppercase">
    {children}
  </span>
);

export default SectionBadge;
